export default "__VITE_ASSET__e4e95197__"